export default theme => ({
  dialog: {
    maxWidth: 950,
  },
  dialog_text__small: {
    "& a": {
      fontSize: theme.textSizes[0],
    },
  },
  toolButton: {
    width: "100%",
    "& a, button": {
      width: "inherit",
    },
  },
  toolButton_text__small: {
    width: "100%",
    "& a": {
      fontSize: theme.textSizes[0],
    },
    "& a, button": {
      width: "inherit",
    },
  },
  remote_production_available_error: {
    color: theme.palette.secondary.main,
  },
});
